import { render } from "./Add_aluminium_profile.vue?vue&type=template&id=201653d3"
import script from "./Add_aluminium_profile.vue?vue&type=script&lang=js"
export * from "./Add_aluminium_profile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__